/* eslint-disable no-restricted-globals */
/* eslint-disable react-hooks/rules-of-hooks */
import React, { useEffect, useState } from 'react'

import './dashboard.scss'

import Menu from '../../../components/InternalMenu/Menu'

import qr from '../../../assets/svg/qr.svg'
import resturant from '../../../assets/svg/resturant.svg'
import category from '../../../assets/svg/category.svg'
import food from '../../../assets/svg/food.svg'
import bg from '../../../assets/svg/bg.svg'
import CustomerClub from '../../../assets/svg/DashboardIconColorfull.svg'

import { notify } from '../../../components/Toast'

import { useNavigate } from 'react-router-dom'
import { Link } from 'react-router-dom'
import { get } from '../../../services/http'

export default function index() {
  const navigate = useNavigate()

  document.title = 'داشبورد'

  const token = localStorage.getItem('token')

  const [shops, setShops] = useState('')
  const [categories, setCategories] = useState('')
  const [foods, setFoods] = useState('')

  useEffect(() => {
    get(`/api/admin/im/dashboard/?token=${token}`)
      .then(response => {
        setShops(response.data.data.shops.length)
        setCategories(response.data.data.categories.length)
        setFoods(response.data.data.foods.length)
      }).catch(error => {
        console.log(error)
        notify('error', 'دریافت اطلاعات با خطا مواجه شد')
      })
  }, [token])

  return (
    <main id='dashboard'>
      <Menu page={'dashboardIn'} badgeCountDashboard={0} badgeCountOrder={0} />
      <article className='dashboardBody'>
        <section className='dashboardContent'>
          <div className='analytics'>
            <div className="moduleTitle">
              ماژول‌ها
            </div>
          </div>
          <div className="modules">
            <Link to='/dashboard'>
              <img style={{ width: '57px',padding: '1em' }} src={CustomerClub} alt="CustomerClub" />
              <hr />
              <section className='modulesText'>
                داشبورد
              </section>
            </Link>
          </div>
          <div className='analytics'>
            <div className='qrSection'>
              <div className='text'>
                <span>کیوآرکد</span>
                <span>QR Code</span>
              </div>
              <hr />
              <div className='qr'>
                <img width={215} src={qr} alt='qr' />
              </div>
              <hr />
              <div className='suggestText'>
                با استفاده از دوربین خود اسکن کنید
              </div>
            </div>
            <div className='lineChart'>
              
            </div>
          </div>

          <div className='crateSection'>
            <div className='resturant'>
              <img src={bg} alt='bg' />
              <div className='up'>
                <img src={resturant} alt='resturant' />
                <section className='text'>
                  <span>قدم اول</span> : ایجاد رستوران یا کافی شاپ
                </section>
              </div>
              <div className='down'>
                <button onClick={() => navigate('/im/resturants/create')}>
                  ایجاد
                </button>
                <Link to='/im/resturants' className='outlineLink'>
                  لیست رستوران‌ها
                </Link>
              </div>
            </div>
            <div className='category'>
              <img src={bg} alt='bg' />
              <div className='up'>
                <img src={category} alt='category' />
                <section className='text'>
                  <span>قدم دوم</span> : ایجاد دسته بندی
                </section>
              </div>
              <div className='down'>
                <button onClick={() => navigate('/im/categories/create')}>
                  ایجاد
                </button>
                <Link to='/im/categories' className='outlineLink'>
                  لیست دسته بندی‌ها
                </Link>
              </div>
            </div>
            <div className='food'>
              <img src={bg} alt='bg' />
              <div className='up'>
                <img src={food} alt='food' />
                <section className='text'>
                  <span>قدم سوم</span> : ایجاد غذا یا نوشیدنی
                </section>
              </div>
              <div className='down'>
                <button onClick={() => navigate('/im/foods/create')}>
                  ایجاد
                </button>
                <Link to='/im/foods' className='outlineLink'>
                  لیست غذا و نوشیدنی
                </Link>
              </div>
            </div>
          </div>

          <div className="statistics">
            <div className='card'>
              <div className='title'>
                تعداد رستوران ها :
              </div>
              <div className='value'>
                {shops} عدد
              </div>
            </div>
            <div className='card'>
              <div className='title'>
                تعداد دسته بندی ها :
              </div>
              <div className='value'>
                {categories} عدد
              </div>
            </div>
            <div className='card'>
              <div className='title'>
                تعداد غذا یا نوشیدنی ها :
              </div>
              <div className='value'>
                {foods} عدد
              </div>
            </div>
          </div>

          <div className="copyright">
            © تمامی حقوق برای <a href='https://ibills.ir'>ibills</a> محفوظ است. طراحی و توسعه توسط <a href='https://ham-team.ir'>هم تیم</a>
          </div>
        </section>
      </article>
    </main>
  )
}
